import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL Categories SERVICE
export const getAllCategoriesService = createAsyncThunk(
  "categories/getAllCategoriesService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.categoriesURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE CATEGORY SERVICE
export const createCategorieservice = createAsyncThunk(
  "categories/createCategorieservice",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.categoriesURL, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE CATEGORY SERVICE
export const deleteCategorieservice = createAsyncThunk(
  "categories/deleteCategorieservice",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.categoriesURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE CATEGORY SERVICE
export const updateCategorieservice = createAsyncThunk(
  "categories/updateCategorieservice",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.clientsURL}${params?.id}`,
        params.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET CATEGORY BY ID SERVICE
export const getCategoryByIdService = createAsyncThunk(
  "categories/getCATEGORYByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.categoriesURL}${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
